export default {
    URL: 'http://myanpr.in:5200/api/v1/',
    LOC_NAME: 'Greenpark',
    LOCATION: 'Greenpark Hotels',
    ORG_CODE: 'GPGH'
}
